module.exports = __webpack_public_path__ + "assets/img/hero-mobile.ff6d4922.jpg";